var map = {
	"./AED-flag.svg": [
		"2c9b",
		"chunk-2d0bd670"
	],
	"./AKZ-flag.svg": [
		"5f24",
		"chunk-2d0d3dc9"
	],
	"./CAD-flag.svg": [
		"135a",
		"chunk-2d0aad64"
	],
	"./CHF-flag.svg": [
		"b72a",
		"chunk-2d21023a"
	],
	"./CNY-flag.svg": [
		"0ea2",
		"chunk-2d0af9dc"
	],
	"./DKK-flag.svg": [
		"06a7",
		"chunk-2d0a4972"
	],
	"./EUR-flag.svg": [
		"66d2",
		"chunk-2d0d0404"
	],
	"./GBP-flag.svg": [
		"9d54",
		"chunk-2d0f0820"
	],
	"./JPY-flag.svg": [
		"a4c4",
		"chunk-2d20885a"
	],
	"./MZN-flag.svg": [
		"fae3",
		"chunk-2d23775f"
	],
	"./NAD-flag.svg": [
		"72bb",
		"chunk-2d0d6951"
	],
	"./NOK-flag.svg": [
		"3ebf",
		"chunk-2d0c574c"
	],
	"./SEK-flag.svg": [
		"77d7",
		"chunk-2d0d7c29"
	],
	"./USD-flag.svg": [
		"d206",
		"chunk-2d21d7ca"
	],
	"./XAF-flag.svg": [
		"0900",
		"chunk-2d0a4ebf"
	],
	"./ZAR-flag.svg": [
		"9417",
		"chunk-2d0e5377"
	],
	"./flag.svg": [
		"1373",
		"chunk-2d0aad74"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "48bc";
module.exports = webpackAsyncContext;